/* eslint-disable security/detect-object-injection */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/function-component-definition */
import React, { memo, useEffect } from "react";
import CustomizedSwitches from "src/shared/CustomToggleButton";
import CustomCheckBox from "src/shared/CustomCheckBox";
import MedicalTextBox from "../MedicalTextBox";

interface Props {
  questions: Record<string, any>;
  isReview: boolean;
  formValues: any;
  setFieldValue: any;
  error: any;
  touch: any;
  handleChanges: any;
  handleBlurs: any;
  gender: string;
}

const JFSMedicalQuestions: React.FC<Props> = ({
  questions,
  isReview,
  formValues,
  setFieldValue,
  error,
  touch,
  handleChanges,
  handleBlurs,
  gender
}) => {
  console.log("formik values", formValues?.medicalDetails, error, touch);
  // console.log("JIO formik values", {
  //   heartDisease: formValues?.medicalDetails?.heartDisease,
  //   strokeTIA: formValues?.medicalDetails?.strokeTIA,
  //   lungDisease: formValues?.medicalDetails?.lungDisease,
  //   highCholesterol: formValues?.medicalDetails?.highCholesterol,
  //   hivAidsSTI: formValues?.medicalDetails?.hivAidsSTI,
  //   congenitalDefect: formValues?.medicalDetails?.congenitalDefect,
  //   genitourinaryHearingVisionDisorder:
  //     formValues?.medicalDetails?.genitourinaryHearingVisionDisorder,
  //   paralysis: formValues?.medicalDetails?.paralysis,
  //   mentalPsychiatricDisorder: formValues?.medicalDetails?.mentalPsychiatricDisorder,
  //   brainNervousSystemDisorder: formValues?.medicalDetails?.brainNervousSystemDisorder,
  //   muscleBoneJointDisorder: formValues?.medicalDetails?.muscleBoneJointDisorder,
  //   bloodCirculatoryDisorder: formValues?.medicalDetails?.bloodCirculatoryDisorder,
  //   thyroidDisorder: formValues?.medicalDetails?.thyroidDisorder,
  //   chronicDigestiveDisorder: formValues?.medicalDetails?.chronicDigestiveDisorder,
  //   endocrineDisorder: formValues?.medicalDetails?.endocrineDisorder,
  //   anyOtherDisease: formValues?.medicalDetails?.anyOtherDisease,
  //   weightLossProgram: formValues?.medicalDetails?.weightLossProgram,
  //   investigateCheckups: formValues?.medicalDetails?.investigateCheckups,
  //   personalConsumptionSmoking: formValues?.medicalDetails?.personalConsumptionSmoking,
  //   personalConsumptionTobacco: formValues?.medicalDetails?.personalConsumptionTobacco,
  //   personalConsumptionAlcohol: formValues?.medicalDetails?.personalConsumptionAlcohol,
  //   isOccupationHazardious: formValues?.medicalDetails?.isOccupationHazardious,
  //   mines: formValues?.medicalDetails?.mines,
  //   explosives: formValues?.medicalDetails?.explosives,
  //   radiation: formValues?.medicalDetails?.radiation,
  //   corrosiveChemicals: formValues?.medicalDetails?.corrosiveChemicals,
  //   hobbyQuery: formValues?.medicalDetails?.hobbyQuery,
  //   aviation: formValues?.medicalDetails?.aviation,
  //   diving: formValues?.medicalDetails?.diving,
  //   mountaineering: formValues?.medicalDetails?.mountaineering,
  //   seaDiving: formValues?.medicalDetails?.seaDiving,
  //   motorRacing: formValues?.medicalDetails?.motorRacing,
  //   bungeeJumping: formValues?.medicalDetails?.bungeeJumping,
  //   familyHealthQuery: formValues?.medicalDetails?.familyHealthQuery,
  //   femaleOrientedQuery: formValues?.medicalDetails?.femaleOrientedQuery
  // });

  // console.log("Formik errors", error);

  useEffect(() => {
    if (!formValues?.medicalDetails?.isOccupationHazardious) {
      setFieldValue("medicalDetails.mines", false);
      setFieldValue("medicalDetails.explosives", false);
      setFieldValue("medicalDetails.radiation", false);
      setFieldValue("medicalDetails.corrosiveChemicals", false);
    }
  }, [formValues?.medicalDetails?.isOccupationHazardious]);

  useEffect(() => {
    if (!formValues?.medicalDetails?.hobbyQuery) {
      setFieldValue("medicalDetails.aviation", false);
      setFieldValue("medicalDetails.diving", false);
      setFieldValue("medicalDetails.mountaineering", false);
      setFieldValue("medicalDetails.seaDiving", false);
      setFieldValue("medicalDetails.motorRacing", false);
      setFieldValue("medicalDetails.bungeeJumping", false);
    }
  }, [formValues?.medicalDetails?.hobbyQuery]);

  useEffect(() => {
    if (gender === "Male") {
      setFieldValue("medicalDetails.femaleOrientedQuery", false);
      setFieldValue("medicalDetails.femalePregnanacyQuery", false);
    }
  }, [gender]);

  return (
    <>
      {questions?.weightLossProgram && (
        <>
          <div className="flex items-center mb-6">
            <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
              {questions?.weightLossProgram}
            </p>
            <CustomizedSwitches
              isEnabled={!isReview}
              toggleState={formValues.medicalDetails.weightLossProgram}
              fieldName="weightLossProgram"
              setFieldValue={setFieldValue}
              fieldObj="medicalDetails"
            />
          </div>
          <hr className="border-dashed border-t-2 mt-10 mb-6.5 border-daintree  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-0 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-0" />
        </>
      )}

      {questions?.sufferingTreatment?.heading && (
        <div className="flex items-center my-6">
          <p className="xl:w-270 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-0 lg:mr-0 md:mr-0 sm:mr-0 mr-17.25 ">
            {questions?.sufferingTreatment?.heading}
          </p>
        </div>
      )}

      {questions?.sufferingTreatment?.heading &&
        Object.entries(questions?.sufferingTreatment)
          ?.filter(([key]) => key !== "heading")
          ?.map(([key, value]) => (
            <div className="flex items-center mb-6" key={key}>
              <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
                {value as string}
              </p>
              <CustomizedSwitches
                isEnabled={!isReview}
                toggleState={formValues.medicalDetails?.[key]}
                fieldName={key}
                setFieldValue={setFieldValue}
                fieldObj="medicalDetails"
              />
            </div>
          ))}

      {questions?.anyOtherDisease && (
        <>
          <div className="mb-6">
            <div className="flex">
              <p className="w-219.25 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4">
                {questions?.anyOtherDisease}
              </p>
            </div>
            <div className=" xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4 mt-4 ">
              <MedicalTextBox
                label="Enter..."
                onChange={handleChanges}
                handleBlur={handleBlurs}
                value={formValues?.medicalDetails?.anyOtherDisease}
                name="medicalDetails.anyOtherDisease"
                error={error?.medicalDetails?.anyOtherDisease}
                touched={touch?.medicalDetails?.anyOtherDisease}
                disabledField={isReview}
              />
            </div>
          </div>
          <hr className="border-dashed border-t-2 mt-10 mb-6.5 border-daintree  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-0 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-0" />
        </>
      )}

      {questions?.investigateCheckups && (
        <>
          <div className="flex items-center mb-6">
            <p className="xl:w-219.25 lg:w-auto md:w-auto sm:w-auto w-67.25 xl:h-24 h-auto flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-39 lg:mr-39 md:mr-39 sm:mr-39 mr-4 ">
              {questions?.investigateCheckups}
            </p>
            <CustomizedSwitches
              isEnabled={!isReview}
              toggleState={formValues.medicalDetails.investigateCheckups}
              fieldName="investigateCheckups"
              setFieldValue={setFieldValue}
              fieldObj="medicalDetails"
            />
          </div>
          <hr className="border-dashed border-t-2 mt-10 mb-6.5 border-daintree  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-0 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-0" />
        </>
      )}

      {questions?.personalConsumption?.heading && (
        <div className="flex items-center my-6">
          <p className="xl:w-270 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-0 lg:mr-0 md:mr-0 sm:mr-0 mr-17.25 ">
            {questions?.personalConsumption?.heading}
          </p>
        </div>
      )}

      {questions?.personalConsumption?.smoking && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.personalConsumption?.smoking}
          </p>
          <CustomizedSwitches
            isEnabled={!isReview}
            toggleState={formValues.medicalDetails.personalConsumptionSmoking}
            fieldName="personalConsumptionSmoking"
            setFieldValue={setFieldValue}
            fieldObj="medicalDetails"
          />
        </div>
      )}

      {questions?.personalConsumption?.tobacco && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.personalConsumption?.tobacco}
          </p>
          <CustomizedSwitches
            isEnabled={!isReview}
            toggleState={formValues.medicalDetails.personalConsumptionTobacco}
            fieldName="personalConsumptionTobacco"
            setFieldValue={setFieldValue}
            fieldObj="medicalDetails"
          />
        </div>
      )}

      {questions?.personalConsumption?.alcohol && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.personalConsumption?.alcohol}
          </p>
          <CustomizedSwitches
            isEnabled={!isReview}
            toggleState={formValues.medicalDetails.personalConsumptionAlcohol}
            fieldName="personalConsumptionAlcohol"
            setFieldValue={setFieldValue}
            fieldObj="medicalDetails"
          />
        </div>
      )}

      {questions?.personalConsumption?.drugNarcotics && (
        <>
          <div className="flex items-center mb-6">
            <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
              {questions?.personalConsumption?.drugNarcotics}
            </p>
            <CustomizedSwitches
              isEnabled={!isReview}
              toggleState={formValues.medicalDetails.personalConsumptionDrugNarcotics}
              fieldName="personalConsumptionDrugNarcotics"
              setFieldValue={setFieldValue}
              fieldObj="medicalDetails"
            />
          </div>
          <hr className="border-dashed border-t-2 mt-5 mb-6.5 border-daintree  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-0 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-0" />
        </>
      )}

      {questions?.occupationQuery?.isOccupationHazardious && (
        <>
          <div className="flex items-center">
            <p className="xl:w-219.25 lg:w-auto md:w-auto sm:w-auto w-67.25 h-auto flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-39 lg:mr-39 md:mr-39 sm:mr-39 mr-4 ">
              {questions?.occupationQuery?.isOccupationHazardious}
            </p>
            <CustomizedSwitches
              isEnabled={!isReview}
              toggleState={formValues.medicalDetails.isOccupationHazardious}
              fieldName="isOccupationHazardious"
              setFieldValue={setFieldValue}
              fieldObj="medicalDetails"
            />
          </div>
          <div className="flex flex-col ml-6 lg:flex-row lg:ml-10 mt-4 flex-wrap gap-2">
            {formValues.medicalDetails?.isOccupationHazardious &&
              Object.entries(questions?.occupationQuery?.hazardOptions)?.map(([key, value]) => (
                <div key={key} className="flex xl:mb-0 lg:mb-0 md:mb-11 sm:mb-9 mb-9">
                  <CustomCheckBox
                    label={value as string}
                    name={`medicalDetails.[${key}]`}
                    handleBlur={handleBlurs}
                    setFieldValue={setFieldValue}
                    isReview={isReview}
                    checked={formValues.medicalDetails?.[key]}
                  />
                </div>
              ))}
          </div>
        </>
      )}

      {questions?.occupationQuery?.hobbyQuery && (
        <>
          <div className="flex items-center">
            <p className="xl:w-219.25 lg:w-auto md:w-auto sm:w-auto w-67.25 h-auto flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-39 lg:mr-39 md:mr-39 sm:mr-39 mr-4 ">
              {questions?.occupationQuery?.hobbyQuery}
            </p>
            <CustomizedSwitches
              isEnabled={!isReview}
              toggleState={formValues.medicalDetails.hobbyQuery}
              fieldName="hobbyQuery"
              setFieldValue={setFieldValue}
              fieldObj="medicalDetails"
            />
          </div>
          <div className="flex flex-col ml-6 lg:flex-row lg:ml-10 mt-4 flex-wrap gap-2">
            {formValues.medicalDetails?.hobbyQuery &&
              Object.entries(questions?.occupationQuery?.hobbyOptions)?.map(([key, value]) => (
                <div key={key} className="flex xl:mb-0 lg:mb-0 md:mb-11 sm:mb-9 mb-9">
                  <CustomCheckBox
                    label={value as string}
                    name={`medicalDetails.[${key}]`}
                    handleBlur={handleBlurs}
                    setFieldValue={setFieldValue}
                    isReview={isReview}
                    checked={formValues.medicalDetails?.[key]}
                  />
                </div>
              ))}
          </div>
          <hr className="border-dashed border-t-2 mt-5 mb-6.5 border-daintree  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-0 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-0" />
        </>
      )}

      {gender === "Female" && questions?.femaleOrientedQuery && (
        <div className="flex items-center mb-6">
          <p className="xl:w-219.25 lg:w-auto md:w-auto sm:w-auto w-67.25 h-auto flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-39 lg:mr-39 md:mr-39 sm:mr-39 mr-4 ">
            {questions?.femaleOrientedQuery}
          </p>
          <CustomizedSwitches
            isEnabled={!isReview}
            toggleState={formValues.medicalDetails?.femaleOrientedQuery}
            fieldName="femaleOrientedQuery"
            setFieldValue={setFieldValue}
            fieldObj="medicalDetails"
          />
        </div>
      )}

      {gender === "Female" && questions?.femalePregnanacyQuery && (
        <div className="flex items-center mb-6">
          <p className="xl:w-219.25 lg:w-auto md:w-auto sm:w-auto w-67.25 h-auto flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-39 lg:mr-39 md:mr-39 sm:mr-39 mr-4 ">
            {questions?.femalePregnanacyQuery}
          </p>
          <CustomizedSwitches
            isEnabled={!isReview}
            toggleState={formValues.medicalDetails?.femalePregnanacyQuery}
            fieldName="femalePregnanacyQuery"
            setFieldValue={setFieldValue}
            fieldObj="medicalDetails"
          />
        </div>
      )}
    </>
  );
};

export default memo(JFSMedicalQuestions);
